"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  socialGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  left: {
    justifyContent: 'flex-start'
  },
  right: {
    justifyContent: 'flex-end'
  },
  leftSpaced: {
    paddingLeft: theme.spacing(1)
  },
  shareButton: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  contentCopyButtonContainer: {
    paddingBottom: '6px'
  },
  contentCopyButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.light
  },
  smallButton: {
    width: '32px',
    height: '32px'
  },
  largeButton: {
    width: '50px',
    height: '50px'
  },
  hiddenInput: {
    position: 'absolute',
    margin: -9999
  }
}), {
  name: 'ShareButtonGroup'
});
var _default = exports.default = useStyles;